import React from 'react';
import "../LoggedNavigation/LoggedCss.css";
import { ReactComponent as Logo } from '../logo.svg';
import { FaRegEnvelope, FaInstagramSquare, FaTwitter, FaTiktok } from 'react-icons/fa';
import { motion } from 'framer-motion';
import tttt from './tttt.jpeg';

import { RiMore2Fill,
          RiDatabase2Fill,RiFocus2Line, RiInformationLine } from "react-icons/ri";


import { ReactComponent as WhiteLogo } from '../buttonEye.svg';

const Home = () => {
  const colors = ['#FD0B0B','#f96c22','#fdeb31','#7bc043','#0392cf','#a660cf']
  return (
    <div className="formContentDiv" style={{ backgroundColor:'#165858',color:"#f8f8f8" }}>
       <motion.div animate={{ scale: [1.03, 1] }}
                  transition={{ ease: "easeIn", duration: 0.3 }} style={{ 
    height:"100%",
    width:"90%",
    padding:"30px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  }}>
        
        <motion.div whileHover={{ scale: 1.01 }} style={{ color:"#b2d8d8", backgroundColor: 'transparent', textAlign: "center", fontFamily: 'Roboto',fontWeight:700, fontSize: '60px', marginBottom: '5px' }}>
         Welcome to Attention Visual
        </motion.div>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
  <img src={tttt} alt="Gaze tracking illustration" style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }} />
</div>
        <motion.div whileHover={{ scale: 1.01 }} style={{ color:"#f8f8f8", backgroundColor: 'transparent', textAlign: "center", fontFamily: 'Comfortaa',fontWeight:600, fontSize: '35px', marginBottom: '20px' }}>
          We're glad to have you on board. With Attention Visual, you can take gaze tracking tests that adapt to your level, track your progress over time, and practice your visual-spatial attention.
        </motion.div>
        
       
        <motion.div style={{color:"#b2d8d8" ,fontFamily: 'Roboto, serif', fontWeight: 300, fontSize: '22px', textAlign: "center", marginBottom: '50px' }}>
           As a registered user, you can:<br></br><br></br>
<motion.span whileHover={{ fontSize: '24px', color: "#f8f8f8"}} >
<WhiteLogo style={{width:"30px",height:"30px"}}/> Take gaze tracking tests with five different visual illusions.<br></br><br></br></motion.span>
<motion.span whileHover={{ fontSize: '24px', color: "#f8f8f8"}} >
<WhiteLogo style={{width:"30px",height:"30px"}}/>  See your scores across sessions on an interactive chart.<br></br><br></br></motion.span>
<motion.span whileHover={{ fontSize: '24px', color: "#f8f8f8"}} >
<WhiteLogo style={{width:"30px",height:"30px"}}/>  Review detailed breakdowns of each test you complete.<br></br><br></br></motion.span>

        </motion.div>
<motion.div whileHover={{ scale: 1.01 }} style={{ color:"#f8f8f8", backgroundColor: 'transparent', textAlign: "center", fontFamily: 'Roboto,serif',fontWeight:200, fontSize: '20px', marginBottom: '20px' }}>
        Use the navigation bar to access these sections:
        </motion.div>
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginBottom: '20px' }}>
  <div style={{ display: "grid", justifyContent: "center", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gridGap: "20px", justifyItems: "center"}}>
    {[
      {
        title: "MyApp",
        text: "Launch the gaze tracking app and take a new session of tests.",
        icon: <RiFocus2Line style={{ width:"50px",height:"50px", color:colors[0]}}/>,
      },
      {
        title: "MyData",
        text: "See your scores across sessions and breakdowns of each test.",
        icon: <RiDatabase2Fill style={{ width:"50px",height:"50px", color:colors[1]}}/>,
      },
      {
        title: "Info",
        text: "Read more about the tool, the research, and how it works.",
        icon: <RiInformationLine style={{ width:"50px",height:"50px", color:colors[2]}}/>,
      },
      {
        title: "Settings and Logout",
        text: "Update your email or password, contact us, or log out.",
        icon: <RiMore2Fill style={{ width:"50px",height:"50px", color:colors[3]}}/>,
      },
    ].map((feature, index) => (
      <motion.div key={index} whileHover={{ scale: 1.15 }} style={{ width: "200px", padding: "10px", display: "grid", gridTemplateRows: "100px auto auto", textAlign: "center", fontFamily: 'Karla', fontSize: '14px', marginBottom: "20px" }}>
        <div style={{ marginBottom: "10px", alignSelf: "center", justifySelf: "center" }}>
          {feature.icon}
        </div>
        <div style={{ fontWeight: '700', fontSize: "16px", marginBottom: '5px', alignSelf: "start" }}>{feature.title}<br></br>
          <span style={{ fontWeight: '400', color: "#b2d8d8" }}>{feature.text}</span>
        </div>
      </motion.div>
    ))}
  </div>
</div>
        
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginBottom: '20px' }}>
  

          
        </div>

      <div style={{
  borderTop: '1px solid #b2d8d8',
  padding: '20px',
  textAlign: 'center',
  fontFamily: 'Roboto Mono',
  fontWeight:400,
}}>
 <div style={{ display: "flex", justifyContent: "center", marginBottom: '20px' }}></div>
<motion.div whileHover={{ scale: 1.02 }} style={{ whiteSpace: 'nowrap', margin: '18px',marginBottom:"5px" }}>
      Contact Us:
    </motion.div>
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '14px', fontFamily: 'Roboto', flexWrap: 'wrap' }}>
    
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaRegEnvelope style={{ color: "#D66532", fontSize: "25px" }} /> <a style={{color:"#D66532"}} href="mailto:info@attentionvisual.com">&nbsp;info@attentionvisual.com</a></span>
    </motion.div>
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaInstagramSquare style={{ color: "#C13584", fontSize: "25px" }} /> <a style={{color:"#C13584"}} href="https://www.instagram.com/attentionvisual" target="_blank" rel="noreferrer">@attentionvisual</a></span>
    </motion.div>
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaTiktok style={{color:"#000000", fontSize:"25px"}}/> <a style={{color:"#000000"}} href="https://www.tiktok.com/@attentionvisual" target="_blank" rel="noopener noreferrer">@attentionvisual</a></span>
    </motion.div>
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaTwitter style={{ color: "#1DA1F2", fontSize: "25px" }} /> <a style={{color:"#1DA1F2"}} href="https://www.twitter.com/attentionvisual" target="_blank" rel="noreferrer">@attentionvisual</a></span>
    </motion.div>

    <motion.div whileHover={{ scale: 1.05 }} style={{ whiteSpace: 'nowrap', margin: '18px' }}>
                  <div

                      

                       style={{
                              fontSize: '18px',
                              fontFamily: 'Roboto Mono, serif',
                              fontWeight: '500',
                              color:"f8f8f8"
                             }}

                   
                    >
      <Logo style={{ width: '45px', height: '45px' }} />
      &nbsp;ATTENTION VISUAL&nbsp;
      <Logo
        style={{ width: '45px', height: '45px', transform: 'scaleX(-1)' }}
      />
    </div>
  </motion.div>
  </div>
                  
</div>
       
      </motion.div>
    </div>
  );
};

export default Home;